module.exports = __webpack_public_path__ + "img/coupon-bg.d53205f8.png";